module.exports = __webpack_public_path__ + "static/img/scene-4.7cee2e5e.jpg";